<script lang="ts">
  import type {
    IFormRatingScaleNode,
    PartialNode,
  } from "@shared/common/node/type";
  import { generateFormDataName } from "@shared/common/utils/form";
  import detectReaction from "../../actions/detect-reaction";
  import { getCurrentDocumentNode, getStore } from "../../context";
  import FormLabel from "./form/form-label.svelte";

  const { reactionEventListener } = getStore();

  const documentNode = getCurrentDocumentNode();

  export let node: PartialNode<IFormRatingScaleNode>;

  $: name = generateFormDataName(node);

  const min = node.min || 1;
</script>

<div
  use:detectReaction={{
    node,
    documentNode,
    onAction: reactionEventListener,
  }}
>
  <FormLabel label={node.label} required={node.required} />
  <div class="rating-scale">
    {#each Array(node.range) as _, idx}
      <label for={`${name}_${idx}`} class="rating-scale-point">
        <!-- input[hidden]이면 validation 툴팁이 노출되지 않으므로 스타일로 가려야 함  -->
        <input
          {name}
          type="radio"
          value={min + idx}
          id={`${name}_${idx}`}
          required={node.required}
        />
        <div>{min + idx}</div>
      </label>
    {/each}
  </div>

  <div class="rating-scale-description">
    <span>{node.description?.left}</span>
    <span>{node.description?.right}</span>
  </div>
</div>

<style>
  .rating-scale {
    margin-top: calc(var(--cb-form-font-size) * 0.5);
    display: flex;
    width: 100%;
    height: 48px;
    border: 1px solid rgba(var(--cb-form-primary-color), 0.5);
    border-radius: 4px;
  }

  .rating-scale-point {
    flex-grow: 1;
    flex-basis: 0;
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    color: rgba(var(--cb-form-primary-color), 0.7);
    font-size: var(--cb-text-lg);
    line-height: var(--cb-line-height-lg);
    padding-top: calc(var(--cb-form-font-size) * 0.5);
    padding-bottom: calc(var(--cb-form-font-size) * 0.5);
    cursor: pointer;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }

  .rating-scale-point input[type="radio"] {
    position: absolute;
    inset: 0;
    opacity: 0;
    pointer-events: none;
  }

  .rating-scale-point:not(:last-child) {
    border-right: 1px solid rgba(var(--cb-form-primary-color), 0.5);
  }

  .rating-scale-point:has(input:checked) {
    background-color: rgba(var(--cb-form-primary-color), 1);
    color: white;
  }

  .rating-scale-point:not(:has(input:checked)):hover {
    background-color: rgba(var(--cb-form-primary-color), 1);
    color: white;
  }

  .rating-scale-description {
    margin-top: calc(var(--cb-form-font-size) * 0.5);
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: var(--cb-text-base);
    line-height: var(--cb-line-height-base);
    color: rgba(var(--cb-form-font-color), 0.6);
  }
</style>
